import { NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxUiLoaderConfig, NgxUiLoaderModule, NgxUiLoaderRouterModule} from 'ngx-ui-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { ngxUiLoaderConfig } from './shared/ui-loader';
import { ToastrModule } from 'ngx-toastr';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { DatePipe, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { SocialLoginModule, GoogleLoginProvider, SocialAuthServiceConfig, FacebookLoginProvider } from '@abacritt/angularx-social-login';
import { LoginModule } from './auth_login/login/login.module';
import { GlobalInterceptor } from './core/interceptor/httpInterceptor.service';
import { CurrentLocationService } from './core/services/currentlocation.service';
import { AdsenseModule } from 'ng2-adsense';





const ngxUiLoaderConfigs: NgxUiLoaderConfig = ngxUiLoaderConfig


@NgModule({ declarations: [
        AppComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        NgxUiLoaderRouterModule,
        SocialLoginModule,
        LoginModule,
        NgxUiLoaderModule.forRoot(ngxUiLoaderConfigs),
        AdsenseModule.forRoot({
            adClient: 'ca-pub-9097815102335625',
            adSlot: 4976751508,
        }),
        ToastrModule.forRoot({
            maxOpened: 1,
            preventDuplicates: true,
            timeOut: 3000,
            positionClass: "toast-top-right",
            closeButton: false,
            newestOnTop: true,
            extendedTimeOut: 1000
        })], providers: [DatePipe, {
            provide: 'SocialAuthServiceConfig',
            useValue: {
                autoLogin: false,
                providers: [
                    {
                        id: GoogleLoginProvider.PROVIDER_ID,
                        provider: new GoogleLoginProvider('381101938087-kdlldst53d0najmjjm0e94cu1s6a6k71.apps.googleusercontent.com', {
                            oneTapEnabled: false
                        }),
                    },
                    {
                        id: FacebookLoginProvider.PROVIDER_ID,
                        provider: new FacebookLoginProvider('614177292955735', {
                            oneTapEnabled: false
                        })
                    }
                ],
                onError: (err: any) => {
                    // Handle social login errors gracefully
                    console.warn('Social login error:', err);
                }
            } as SocialAuthServiceConfig,
        }, { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, multi: true }, CurrentLocationService,
        { provide: LocationStrategy, useClass: PathLocationStrategy }, provideHttpClient(withInterceptorsFromDi()), provideClientHydration()] })
export class AppModule { }
